﻿//Development settings
// var AUTH_SERVER = 'http://localhost:5000/'; 
// var AUTH_REDIRECT = 'http://localhost:4200/';
// var API_ADMIN = 'http://localhost:49160/api/';
// var API_WORKORDER = 'http://localhost:13632/api/';
// var API_CUSTOMER = 'http://localhost:53601/api/';
// var API_COMPANY = 'http://localhost:4419/api/'; 
// var API_TECHNICIAN = 'http://localhost:54044/api/';
// var API_SCHEDULING = 'http://localhost:52557/api/';
// var API_PM = 'http://localhost:25510/api/';
// var API_INVENTORY = 'http://localhost:15455/api/'; 
// var API_Report = 'http://localhost:18500/api/';
// var DevExpress_URL = 'http://172.16.0.108/DevExpress/';
// var DOTNETREPORT='http://172.16.0.108:83/AdhocReport/Report'; 
// var API_TXTCHAT = 'https://chat.ducont.com:4000/';//'https://chat.fieldpower.com/';
// var FP_HELP='https://fpdev.fieldpower.com/FPHelp/';
// var API_CUSTOMERPORTAL = 'http://localhost:53455/api/';
// var API_WEBSCH = 'http://localhost:51529/api/';

//FPDev
var AUTH_SERVER = 'https://testfpcloud.fsmgrid.com/FPIdentity/';
var AUTH_REDIRECT = 'https://testfpcloud.fsmgrid.com/';
var API_ADMIN = 'https://testfpcloud.fsmgrid.com/FPAdmin/api/';
var API_WORKORDER = 'https://testfpcloud.fsmgrid.com/FPWorkOrder/api/';
var API_CUSTOMER = 'https://testfpcloud.fsmgrid.com/FPCustomer/api/';
var API_COMPANY = 'https://testfpcloud.fsmgrid.com/FPCompany/api/';
var API_TECHNICIAN = 'https://testfpcloud.fsmgrid.com/FPTechnician/api/';
var API_SCHEDULING = 'https://testfpcloud.fsmgrid.com/FPScheduling/api/';
var API_PM = 'https://testfpcloud.fsmgrid.com/FPPM/api/';
var API_INVENTORY = 'https://testfpcloud.fsmgrid.com/FPInventory/api/';
var API_Report = 'https://testfpcloud.fsmgrid.com/FPReport/api/';
var API_CUSTOMERPORTAL = 'https://testfpcloud.fsmgrid.com/FPCPortal/api/';
var API_WEBSCH = 'https://testfpcloud.fsmgrid.com/FPWebScheduler/api/';
var DevExpress_URL = 'https://testfpcloud.fsmgrid.com/DevExpress/';
var DOTNETREPORT = 'https://testfpcloud.fsmgrid.com/FPAdhocReport/';
var API_WEBSCH = 'https://testfpcloud.fsmgrid.com/FPWebScheduler/api/';
var FP_HELP='https://testfpcloud.fsmgrid.com/FPHelp/';
var API_TXTCHAT = 'https://chat.ducont.com:4000/'; 


//Testing settings
// var AUTH_SERVER = 'https://fptest.fieldpower.com:81/FPIdentity/';
// var AUTH_REDIRECT = 'https://fptest.fieldpower.com:81/';
// var API_ADMIN = 'https://fptest.fieldpower.com:81/FPAdmin/api/';
// var API_WORKORDER = 'https://fptest.fieldpower.com:81/FPWorkOrder/api/';
// var API_CUSTOMER = 'https://fptest.fieldpower.com:81/FPCustomer/api/';
// var API_COMPANY = 'https://fptest.fieldpower.com:81/FPCompany/api/';
// var API_TECHNICIAN = 'https://fptest.fieldpower.com:81/FPTechnician/api/';
// var API_SCHEDULING = 'https://fptest.fieldpower.com:81/FPScheduling/api/';
// var API_PM = 'https://fptest.fieldpower.com:81/FPPM/api/';
// var API_INVENTORY = 'https://fptest.fieldpower.com:81/FPInventory/api/';
// var API_Report = 'https://fptest.fieldpower.com:81/FPReport/api/';
// var API_CUSTOMERPORTAL = 'https://fptest.fieldpower.com:81/FPCPortal/api/';
// var API_WEBSCH = 'https://fptest.fieldpower.com:81/FPWebScheduler/api/';
// var DevExpress_URL = 'https://fptest.fieldpower.com:81/DevExpress/';
// var DOTNETREPORT = 'https://fptest.fieldpower.com:81/FPAdhocReport/Report';
// var API_WEBSCH = 'https://fptest.fieldpower.com:81/FPWebScheduler/api/';
// var FP_HELP='https://fptest.fieldpower.com:81/FPHelp/';
// var API_TXTCHAT = 'https://chat.ducont.com:4000/'; 
//'https://chat.fieldpower.com/';

//Cloud 
// var AUTH_SERVER = 'https://cloud.fieldpower.com/FPIdentity/';
// var AUTH_REDIRECT = 'https://cloud.fieldpower.com/';
// var API_ADMIN = 'https://cloud.fieldpower.com/FPAdmin/api/';
// var API_CUSTOMERPORTAL = 'https://cloud.fieldpower.com/FPCPortal/api/';
// var API_CUSTOMER = 'https://cloud.fieldpower.com/FPCustomer/api/';
// var API_COMPANY = 'https://cloud.fieldpower.com/FPCompany/api/';
// var API_TECHNICIAN = 'https://cloud.fieldpower.com/FPTechnician/api/';
// var API_SCHEDULING = 'https://cloud.fieldpower.com/FPScheduling/api/';
// var API_PM = 'https://cloud.fieldpower.com/FPPM/api/';
// var API_INVENTORY = 'https://cloud.fieldpower.com/FPInventory/api/';
// var API_WORKORDER = 'https://cloud.fieldpower.com/FPWorkOrder/api/';
// var API_Report = 'https://cloud.fieldpower.com/FPReport/api/';
// var API_WEBSCH = 'https://cloud.fieldpower.com/FPWebScheduler/api/';
// var DOTNETREPORT='https://cloud.fieldpower.com/FPAdhocReport/Report';
// var DevExpress_URL = 'https://cloud.fieldpower.com/FPDevExpress/';
// var API_TXTCHAT = 'https://fieldpowerchat.ducont.com/';
// var FP_HELP='https://cloud.fieldpower.com/FPHelp/';
//'https://chat.fieldpower.com/';

//Testing site2 settings
// var AUTH_SERVER = 'http://61.95.186.63:83/FPIdentity/';
// var AUTH_REDIRECT = 'http://61.95.186.63:83/';
// var API_ADMIN = 'http://61.95.186.63:83/FPAdmin/api/'; 
// var API_WORKORDER = 'http://61.95.186.63:83/FPWorkOrder/api/';
// var API_CUSTOMER = 'http://61.95.186.63:83/FPCustomer/api/';
// var API_COMPANY = 'http://61.95.186.63:83/FPCompany/api/'; 
// var API_TECHNICIAN = 'http://61.95.186.63:83/FPTechnician/api/';
// var API_SCHEDULING = 'http://61.95.186.63:83/FPScheduling/api/';
// var API_PM = 'http://61.95.186.63:83/FPPM/api/';
// var API_INVENTORY = 'http://61.95.186.63:83/FPInventory/api/';
// var API_Report = 'http://61.95.186.63:83/FPReport/api/';
// var API_CUSTOMERPORTAL = 'http://61.95.186.63:83/FPCPortal/api/';
// var API_WEBSCH = 'http://61.95.186.63:83/FPWebScheduler/api/';
// var FP_HELP='https://fpdev.fieldpower.com/FPHelp/';
// var DevExpress_URL = 'http://61.95.186.63:83/DevExpress/';
// var DOTNETREPORT = 'http://61.95.186.63/AdhocReport/Report';
// var API_TXTCHAT = 'https://chat.ducont.com:4000/';  //'https://chat.fieldpower.com/'; 

//Cloud 
// var AUTH_SERVER = 'https://cloud.fieldpower.com/FPIdentity/';
// var AUTH_REDIRECT = 'https://cloud.fieldpower.com/';
// var API_ADMIN = 'https://cloud.fieldpower.com/FPAdmin/api/';
// var API_CUSTOMERPORTAL = 'https://cloud.fieldpower.com/FPCPortal/api/';
// var API_CUSTOMER = 'https://cloud.fieldpower.com/FPCustomer/api/';
// var API_COMPANY = 'https://cloud.fieldpower.com/FPCompany/api/';
// var API_TECHNICIAN = 'https://cloud.fieldpower.com/FPTechnician/api/';
// var API_SCHEDULING = 'https://cloud.fieldpower.com/FPScheduling/api/';
// var API_PM = 'https://cloud.fieldpower.com/FPPM/api/';
// var API_INVENTORY = 'https://cloud.fieldpower.com/FPInventory/api/';
// var API_WORKORDER = 'https://cloud.fieldpower.com/FPWorkOrder/api/';
// var API_Report = 'https://cloud.fieldpower.com/FPReport/api/';
// var API_WEBSCH = 'https://cloud.fieldpower.com/FPWebScheduler/api/';
// var DOTNETREPORT='https://cloud.fieldpower.com/FPAdhocReport/Report';
// var DevExpress_URL = 'https://cloud.fieldpower.com/FPDevExpress/';
// var API_TXTCHAT = 'https://fieldpowerchat.ducont.com/';//'https://chat.fieldpower.com/';
// var FP_HELP='https://cloud.fieldpower.com/FPHelp/';



// var AUTH_SERVER = 'https://fpcloud.fieldpower.com:84/FPIdentity/';
// var AUTH_REDIRECT = 'https://fpcloud.fieldpower.com:84/';
// var API_ADMIN = 'https://fpcloud.fieldpower.com:84/FPAdmin/api/';
// var API_WORKORDER = 'https://fpcloud.fieldpower.com:84/FPWorkOrder/api/';
// var API_CUSTOMER = 'https://fpcloud.fieldpower.com:84/FPCustomer/api/';
// var API_COMPANY = 'https://fpcloud.fieldpower.com:84/FPCompany/api/';
// var API_TECHNICIAN = 'https://fpcloud.fieldpower.com:84/FPTechnician/api/';
// var API_SCHEDULING = 'https://fpcloud.fieldpower.com:84/FPScheduling/api/';
// var API_PM = 'https://fpcloud.fieldpower.com:84/FPPM/api/';
// var API_INVENTORY = 'https://fpcloud.fieldpower.com:84/FPInventory/api/';
// var API_Report='https://fpcloud.fieldpower.com:84/FPReport/api/';
// var DevExpress_URL = 'https://fpcloud.fieldpower.com:84/DevExpress/';

// Demo settings
// var AUTH_SERVER = 'https://demo.fieldpower.com:84/FPIdentity/';
// var AUTH_REDIRECT = 'https://demo.fieldpower.com:84/';
// var API_ADMIN = 'https://demo.fieldpower.com:84/FPAdmin/api/';
// var API_WORKORDER = 'https://demo.fieldpower.com:84/FPWorkOrder/api/';
// var API_CUSTOMER = 'https://demo.fieldpower.com:84/FPCustomer/api/';
// var API_CUSTOMERPORTAL = 'https://demo.fieldpower.com/FPCPortal/api/';
// var API_COMPANY = 'https://demo.fieldpower.com:84/FPCompany/api/';
// var API_TECHNICIAN = 'https://demo.fieldpower.com:84/FPTechnician/api/';
// var API_SCHEDULING = 'https://demo.fieldpower.com:84/FPScheduling/api/';
// var API_PM = 'https://demo.fieldpower.com:84/FPPM/api/';
// var API_INVENTORY = 'https://demo.fieldpower.com:84/FPInventory/api/';
// var API_Report = 'https://demo.fieldpower.com:84/FPReport/api/';
// var DevExpress_URL = 'http://172.16.0.108/DevExpress/';
// var DOTNETREPORT='http://172.16.0.108:83/AdhocReport/Report';
// var API_TXTCHAT = 'https://chat.fieldpower.com/';

// var AUTH_SERVER = 'https://demo.fieldpower.com/FPIdentity/';
// var AUTH_REDIRECT = 'https://demo.fieldpower.com/';
// var API_ADMIN = 'https://demo.fieldpower.com/FPAdmin/api/';
// var API_WORKORDER = 'https://demo.fieldpower.com/FPWorkOrder/api/';
// var API_CUSTOMER = 'https://demo.fieldpower.com/FPCustomer/api/';
// var API_CUSTOMERPORTAL = 'https://demo.fieldpower.com/FPCPortal/api/';
// var API_COMPANY = 'https://demo.fieldpower.com/FPCompany/api/';
// var API_TECHNICIAN = 'https://demo.fieldpower.com/FPTechnician/api/';
// var API_SCHEDULING = 'https://demo.fieldpower.com/FPScheduling/api/';
// var API_PM = 'https://demo.fieldpower.com/FPPM/api/';
// var API_INVENTORY = 'https://demo.fieldpower.com/FPInventory/api/';
// var API_Report = 'https://demo.fieldpower.com/FPReport/api/';
// var DevExpress_URL = 'https://demo.fieldpower.com/DevExpress/';
// var DOTNETREPORT='https://demo.fieldpower.com/DotNetReportClient/Report';
// var API_TXTCHAT = 'https://chat.ducont.com:4000/';
export const IntuitBaseDir =  "https://appcenter.intuit.com/connect/oauth2?client_id=AB2MYAD5yzkHjD6H14pYoo0ruXUqYlBec3muyqsC3EDb2xKgja&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=http%3A%2F%2Flocalhost%3A13632%2Fapi%2Fintuit%2Ftestintuit&state=chk";

//local
export const IntuitFiledpowerHomeUrl =  "https://https://fpdev.fieldpower.com/#/zsl/home";
export const AUTH = Object.freeze({
    AUTHORITY: AUTH_SERVER,
    AUTHORIZE: AUTH_SERVER + 'connect/authorize',
    LOGOUT: AUTH_SERVER + 'connect/endsession',
    USERINFO: AUTH_SERVER + 'connect/userinfo',
    REDIRECT: AUTH_REDIRECT
})

export const API = Object.freeze({
    DOTNETREPORT: DOTNETREPORT,
    BASE: API_CUSTOMER,
    LOGIN: API_CUSTOMER + 'user/login',
    API_ADMIN:API_ADMIN,
    CUSTOMER: API_CUSTOMER + 'customer',
    SKILL: API_ADMIN + 'skill',
    HOLIDAY: API_ADMIN + 'Holiday',
    ROLE: API_ADMIN + 'role',
    USER: API_ADMIN + 'User',
    TXTCHAT: API_TXTCHAT,
    FPHELP:FP_HELP,
    TECHNICIAN: API_TECHNICIAN + 'technicianmaster',
    REGION: API_ADMIN + 'region',
    CERTIFICATION: API_ADMIN + 'certification',
    COMPANYMASTER: API_ADMIN + 'CompanyMaster',
    CUST_FILTER: API_CUSTOMER + 'Customer/CustomerLookup',
    CUSTOMERSTATUS: API_CUSTOMER + 'customer/status',
    CUSTOMERTYPE: API_CUSTOMER + 'CustomerType',
    STATUSREASON: API_WORKORDER + 'StatusReason',
    CONFIGMASTER: API_ADMIN + 'ConfigMaster',
    COMMON: API_ADMIN + 'Common',
    COUNTRY: API_CUSTOMER + 'address/country',
    STATE: API_CUSTOMER + 'address/state',
    ADDRESS: API_CUSTOMER + 'address',
    WORKORDER: API_WORKORDER + 'WorkOrder',
    QUOTE: API_WORKORDER + 'Quotes',
    WOPRIORITY: API_WORKORDER + 'Priority',
    WOCATEGORY: API_WORKORDER + 'workorder/category',
    WOWORKTYPE: API_WORKORDER + 'workorder/worktype',
    WOWORKTASK: API_WORKORDER + 'workorder/worktask',
    WOCONTACT: API_WORKORDER + 'workorder/customer/',
    WOPRICETYPE: API_WORKORDER + 'workorder/pricetype',
    WOSAVE: API_WORKORDER + 'workorder/insert',
    CUSTOMFILEDS: API_ADMIN + 'customfields',
    CLIENTPORTALLOGIN: API_ADMIN + 'ClientPortalLogin',
    CUSTOMERNAMES: API_WORKORDER + 'workorder/customername',
    PRIORITYSLA: API_WORKORDER + 'Priority',
    WOMASTER: API_WORKORDER + 'WorkOrderMaster',
    COMPANY: API_COMPANY + 'Company',
    VENDOR: API_COMPANY + 'Vendor',
    VENDORATTACH: API_COMPANY + 'attachment',
    GETZONE: API_ADMIN + 'Zone/GetAll',
    GETZONEREGIONAVAILABLE: API_ADMIN + 'Zone/GetAvailable',
    GETZONEREGIONALLOTTED: API_ADMIN + 'Zone/GetAllotted',
    GETZONEBYID: API_ADMIN + 'Zone/Get',
    ZONE: API_ADMIN + 'Zone/',
    MANUALEMAILSMS: API_ADMIN + 'ManualEmailSms/',
    SENDMANUALSMSEMAIL: API_WORKORDER + 'SendManualEmailSms/',
    AUTOEMAILTEMPLATE: API_ADMIN + 'AutoEmailTemplate/',
    SCHEDULINGPREFERENCE: API_WORKORDER + 'SchedulingPreference',
    SYSTEMSETTING: API_ADMIN + 'SystemSetting',
    CHECKLIST: API_ADMIN + 'Checklist/',
    RESOURCE: API_ADMIN + 'ResourceFile/',
    TECH_AVAILABILITY: API_TECHNICIAN + 'technician',
    ZIPCODE: API_ADMIN + 'Zipcode',
    TAXMASTER: API_ADMIN + 'Taxmaster',
    TAXGROUPMASTER: API_ADMIN + 'TaxGroup',
    //DispatchBoard
    DISPATCHBOARD: API_WORKORDER + 'DispatchBoard',
    WOVENDOR: API_WORKORDER + 'WOVendor',

   
WEBSCH:API_WEBSCH + 'WebScheduler',


    //Technician job
    WORKORDERMAS: API_WORKORDER + 'WorkOrderMaster',
    SCHEDULING: API_SCHEDULING + 'Appointment',
    //Report
    Report: API_Report + 'Designer',
    ReportCE: API_Report +'CustomerEquipmentReport',
    REPORTS: API_Report + 'CustomerFeedbackReport',
    REPORTMOBILE: API_Report + 'MobileReport',
    REPORTSTATUS: API_Report + 'StatusReason',
    ROLEPRIVILEGE: API_ADMIN + 'RolePrivileges',
    MANAGEWOD: API_WORKORDER + 'ManageWOD/',
    WOCOMPANYMASTER: API_WORKORDER + 'WOCompanyMaster',
    COMPANYCUSTOMER: API_CUSTOMER + 'CompanyCustomer',
    PM: API_PM + 'PMSchedule',
    EQUIPMENTPM: API_PM + 'EquipmentPM',
    REPORT: API_WORKORDER + 'FieldStatus',
    REPORTWO: API_WORKORDER + 'WoSummary',
    REPORTSTOCKSTATUS: API_WORKORDER + 'StockStatus',
    REPORTVANINVENTORY: API_WORKORDER + 'VanInventory',
    CUSTOMREPORT: API_WORKORDER + 'CustomerTest',
    REPORTSLA: API_WORKORDER + 'SLATechReport',
    DEVEXPRESS: API_Report + 'DevExpress',
    PROJECT: API_ADMIN + 'Project',
    PROJECTDOWNLOAD: API_ADMIN + 'ProjectDownLoad',   
    OMANTELREDIRECT: "https://www.omantel.om/wps/portal/",
    //Invoice Queue
    INVOICEQUEUE: API_WORKORDER + 'InvoiceQueue/',
    APPROVALQUEUE: API_WORKORDER + 'ApprovalQueue',
    WOSUMMARYREPORT: "",
    INSTALLATIONCOMPLETEDREPORT: "",
    ATTACHEMNT: API_WORKORDER + 'attachment',
    LIVEMAP: API_WORKORDER + 'LiveMap',
    SCHEDULEOPTIMIZATION: API_WORKORDER + 'ScheduleOptimization',
    BIN: API_INVENTORY + 'bins',
    LOCATION: API_INVENTORY + 'location',
    MODEL: API_INVENTORY + 'model',
    BRAND: API_INVENTORY + 'brand',
    WAREHOUSE: API_INVENTORY + 'warehouse',
    STOCKREQUEST: API_INVENTORY + 'stockrequest',
    PART: API_INVENTORY + 'Part',
    ADJUSTMENT: API_INVENTORY + 'adjustment',
    STOCKTRANSFER: API_INVENTORY + 'stocktransfer',
    TECHPREFERENCE: API_ADMIN + 'TechnicianPreference',   
    TODYSEVENT: API_WORKORDER + 'ToDaysEventReport',
    ICCTRACKING: API_WORKORDER + 'IccTracking',
    DASHBOARD: API_Report + 'DashBoard',
    ASSETTRANSFER: API_CUSTOMER + 'TransferAsset',
    PMATTACHMENT: API_PM + 'PMAttachment',
    TECHUTILREPORT: API_WORKORDER + 'TechUtilReport',
    FPINTEGRATION: API_WORKORDER + 'FPIntegration',
    DASHBOARDPOWERBI: ' https://app.powerbi.com/view?r=eyJrIjoiMTg4ZWQxMzMtMzVmNC00NjNlLWE0NWUtYmUyZTcyMmRkMDA1IiwidCI6IjkyN2I2NDlhLWNkNzMtNGQ3Yy1hOTI0LTAzZGUzMWU4OTBhNSIsImMiOjF9',
    DEVEXPRESSSERVER: DevExpress_URL + 'DevExpress',
    PARTCATEGORY: API_INVENTORY + 'PartCategory',
    POWERBI: API_Report + 'powerbi',
    IMPORTDATA: API_WORKORDER + 'Import',
    CUSTOMVIEW: API_WORKORDER + 'customview',
    TECHCHECKINOUTREPORT: API_Report + 'TechCheckInOut',
    WOPRICINGDETAILREPORT: API_Report + 'WoPricingDetailReport',
    SPEECHSEARCHLANG: "en-us",
    WOPDFMAIL: API_WORKORDER + 'PDFMail',
    IOTORDER: API_WORKORDER + 'Iotalert',
    WORKFLOW: API_WORKORDER + 'WorkFlow',
    WORKORDERCUSTOMEPORTAL: API_CUSTOMERPORTAL + 'WorkOrderCustomer',
    JOBTRACKING: API_WORKORDER + 'jobtracking',

    QBINTEGRSTION: API_Report + 'QBIntegration',
})

export const PERMISSION = Object.freeze({
    // DISPATCH BOARD
    NEARBYTECHPOPUP: true
});

export const SETTINGS = Object.freeze({
    BASEROUTE: "zsl"
});

export const DATAURLS = Object.freeze({
    MAIN: API_Report + "WorkOrderSummary/GetChartDetails?",
    KPI: API_Report + "WorkOrderSummary/GetKPIData?",
    ALL: API_Report + "WorkOrderSummary/GetAllWorkOrder",
    GEOALL: API_Report + "workordersummary/GetAllCompany",
    GEO: API_Report + "WorkOrderSummary/GetWorkOrderByRegion?",
    TREND: API_Report + "WorkOrderSummary/GetWorkOrderByRegion?"
});
export const COLORS = Object.freeze({
    D320C: ["#3182bd", "#6baed6", "#9ecae1", "#c6dbef", "#e6550d", "#fd8d3c", "#fdae6b", "#fdd0a2", "#31a354", "#74c476", "#a1d99b", "#c7e9c0", "#756bb1", "#9e9ac8", "#bcbddc", "#dadaeb", "#636363", "#969696", "#bdbdbd", "#d9d9d9"],
    D320C_REV: ["#c6dbef", "#9ecae1", "#6baed6", "#3182bd", "#fdd0a2", "#fdae6b", "#fd8d3c", "#e6550d", "#c7e9c0", "#a1d99b", "#74c476", "#31a354", "#dadaeb", "#bcbddc", "#9e9ac8", "#756bb1", "#d9d9d9", "#bdbdbd", "#969696", "#636363"]
});
export const supportedLangs = ["en"];

// ,"ar","fr","Benco-ar","EDOTCO-en","SERVMOB-en","ElixirEng-en","PBS2019-en","DUCQAT-en","DUCONTUAE-en","DUCONTSAUD-en","DUCONTKSA-en","DUCLEB-en","DUCEGY-en","DUCONTUAE-ar","DUCONTKSA-ar","MOTOROLA-en","LADNOW-en","DUCOMAN-en","DUCNAMIBIA-en","NAMIBIA-en","ZSLSALES-en","DUCONTIOT-en","ABADIJAYA-en","MITSUBISHI-en","DUCONTSA-en","NSIT-en","MITSU-en","DUCONTUSA-en","BISWAL-en","SPECTRANET-en","METCO-en","METCONW-en","MAREDISA-en","LOMAEN-en","KINETIX-en","ISCENT-en"

export const CURRENCIES =[{ code:'USD',symbol: '$'}, { code:'GBP',symbol: '£'}, { code:'SGD',symbol: 'S$'},{ code:'EUR',symbol: '€'},
                    { code:'AED',symbol: 'AED'}, { code:'VND',symbol: '₫'}, { code:'MYR',symbol: 'RM'},{ code:'SAR',symbol: 'SR'},
                    { code:'INR',symbol: '₹'}, { code:'EGP',symbol: 'E£'}, { code:'BDT',symbol: 'BDT'},{ code:'MMK',symbol: 'MMK'},
                    { code:'PKR',symbol: 'PKR'}, { code:'Philippine peso',symbol: '₱'}, { code:'RAND',symbol: 'R'} ];

export const API_Settings_ERPeSales = Object.freeze({
    BaseURL: "http://api.esales.in/",
    AuthSecret: "PuNbMsQRqjNv",
    AuthCode: "1",
    AddUpdateCustomer: "saveOrUpdateFPContact",
    AddUpdateCustomerAddress: "saveOrUpdateFPContactAddress",
    AddUpdateCustomerContact: "saveOrUpdateFPContactPersons",
    DeleteCustomer: "deleteContact",
    // CompanyId:45//UAT Testing
    ERP_CompanyId: 11//local testing
});

